import React from 'react';
import './error-page.style.scss'

function ErrorPage() {
    return (
        <div className='error-page'>
            <h1>404 Page Not Found!</h1>
        </div>
    );
}

export default ErrorPage;
